import { axiosInstance } from "./axiosInstance";


 export const createBioValidation = async (data: any) => {
    const response = await axiosInstance.post("/api/v2/bio-validation", data);
    return response.data;
  }

 

